// extracted by mini-css-extract-plugin
export default {"inputWrap":"ModalAddBag_inputWrap__2Jewe","input":"ModalAddBag_input__307cw","buttonWrap":"ModalAddBag_buttonWrap__qZmDv"};